import {
  BalanceType,
  GetPatientsBalanceResponse,
  GetPatientsBalanceResponse_PatientBalance,
  Provider,
} from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import {
  ListPatientBalancesResponse,
  PatientBalance,
} from '@weave/schema-gen-ts/dist/schemas/payments-integration/collections/v1/service.pb';

// Maps new balanceType string values to legacy BalanceType proto enum values
const BALANCE_TYPE_MAP: Record<string, BalanceType> = {
  NEW: BalanceType.BALANCE_TYPE_NEW,
  CHANGED: BalanceType.BALANCE_TYPE_UPDATE,
  EXISTING: BalanceType.BALANCE_TYPE_EXISTS,
};

export const mapPatientBalance = (pb: PatientBalance): GetPatientsBalanceResponse_PatientBalance => {
  return {
    patientId: pb.patientId ?? '',
    firstName: pb.firstName,
    lastName: pb.lastName,
    phoneNumber: pb.phoneNumber,
    locationIds: pb.location?.id ? [pb.location.id] : [],
    balance: pb.balance ?? 0,
    balanceType: BALANCE_TYPE_MAP[pb.balanceType ?? ''] ?? BalanceType.BALANCE_TYPE_UNKNOWN,
    provider: {} as Provider,
    pmsName: undefined,
    preferredName: undefined,
  };
};

export const mapListPatientBalancesResponse = (
  response: ListPatientBalancesResponse | undefined
): GetPatientsBalanceResponse | undefined => {
  if (!response) return undefined;
  return {
    patientBalances: (response.patientBalances ?? []).map(mapPatientBalance),
  };
};
